import Box from '@/Atoms/Box';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {data, headers} from './helper';
import {FlatList, Text, TouchableOpacity, View} from 'react-native';
import {styles} from './styles';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import CCButton from '@/Atoms/CCButton';
import {FontSizes, isPhone, vs} from '@/Utils/Dimensions';
import Spacer from '@/Atoms/Spacer';
import CCTextInput from '@/Atoms/CCTextInput';
import useGetProfileApi from '@/Hooks/ProfileApi/profileApi';
import {
  faChessPawn,
  faChessKnight,
  faChessQueen,
  faChessBishop,
  faChessRook,
  faChessKing,
  faChess,
  faCreditCard,
  faUser,
  faTriangleExclamation,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import useUpdateProfileApi from '@/Hooks/ProfileApi/profileUpdateApi';
import useGAPageView from '@/navigators/useGAPageView';
import {ScreenName} from '@/navigators/StackConstants';
import CCSelect from '@/Atoms/CCSelect';
import {
  setLocalStorage,
  getLocalStorage,
  getUserDetails,
} from '@/Utils/CommonUtils';
import localforage from 'localforage';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import Header from '@/Atoms/Header';
import {useLoginState} from '@/Hooks/LoginApi/loginApi';
import {lastValueFrom} from 'rxjs';
import CCLoader from '@/Atoms/CCLoader';
import useAlertModalStore from '@/Store/AlertModalStore';
import useResetAccountApi from '@/Hooks/ResetAccount/useResetAccount';
import PlayerTypeSelection from './PlayerTypeSelection';
import SubscriptionManagement from './component/SubscriptionManagement';
import {SUPER_ADMIN} from '@/Utils/Constants';
import {PopUp} from '../Visualisation/components/LevelModal';
import SlideModal from '@/Atoms/SlideModal';
import {useNavigation, useRoute} from '@react-navigation/native';
import SubscriptionTab from './component/SubscriptionTab';
import CCTabs from '@/Atoms/CCTabs';
import useGamePlayState from '@/Store/GamePlayStore';
import useUpdateUserSettingsApi from '@/Hooks/ProfileApi/updateSettingsApi';

function Profile({userData, setUserData}) {
  const route = useRoute();
  const navigation = useNavigation();
  useGAPageView(ScreenName.Settings);
  const gameplayStore = useGamePlayState();

  // Tab state
  const [activeTab, setActiveTab] = useState('profile'); // 'profile' or 'subscriptions'
  const [userTabs, setUserTabs] = useState('profile');
  const [profileData, setProfileData] = useState(null);

  const data = [
    {
      key: 'A',
      icon: faChessPawn,
      name: 'Persistent Pawn',
      tagline:
        'There are so few like you, determined, unrelenting, positional and winner!',
    },
    {
      key: 'B',
      icon: faChessKnight,
      name: 'Killer Knight',
      tagline:
        'Tricky, deceptive, positional and attacking, you are an artist!',
    },
    {
      key: 'C',
      icon: faChessBishop,
      name: 'Blazing Bishop',
      tagline:
        'You fancy blazing through the 64 squares, leaving a trail of destruction!',
    },
    {
      key: 'D',
      icon: faChessRook,
      name: 'Rumbling Rook',
      tagline:
        'You are a heavy weight champion, crushing your enemies beneath your feet.',
    },
    {
      key: 'E',
      icon: faChessQueen,
      name: 'Qrushing Queen',
      tagline:
        'Your aggression has no limits, you crush all that come in your path.',
    },
    {
      key: 'F',
      icon: faChessKing,
      name: 'Kingly King',
      tagline:
        'You are majestic, silent, strategic leader, marshalling your forces to victory!',
    },
  ];

  const [firstName, setFirstName] = useState('');
  const [userName, setUserName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [fideid, setFideid] = useState('');
  const [lichessUsername, setLichessUsername] = useState('');
  const [cdcUsername, setCdcUsername] = useState('');
  const [avatar, setAvatar] = useState('');
  const [avatarDP, setAvatarDP] = useState('');
  const [errorMsg, setErrorMsg] = useState(null);
  const [success, setSuccess] = useState(false);
  const [color, setColor] = useState(null);
  const [dndMode, setDndMode] = useState(undefined);
  const [isSaved, setIsSaved] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isEmailDisabled, setIsEmailDisabled] = useState(false);
  const [isFideDisabled, setIsFideDisabled] = useState(false);
  const [userFlagResetButton, setUserFlagResetButton] = useState(false);
  const [playerType, setPlayerType] = useState();
  const [alternatePhone, setAlternatePhone] = useState('');
  const [newLichessUsername, setNewLichessUsername] = useState('');
  const [editChessUsername, setEditChessUsername] = useState(false);
  const [newCdcUsername, setNewCdcUsername] = useState('');
  const [newMobilePopup, setNewMobilePopup] = useState(false);
  const [originalAlternatePhone, setOriginalAlternatePhone] = useState('');
  const [shouldShowMobilePopupNext, setShouldShowMobilePopupNext] =
    useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState('');
  const [deleteError, setDeleteError] = useState('');
  const [alowUpdate, setAllowUpdate] = useState(false);
  const {
    mutate: resetAccount,
    data: resettingAccountData,
    isLoading: resettingAccountLoader,
    error: resettingAccountError,
  } = useResetAccountApi(
    data => console.log('Success:', data),
    error => console.error('Error:', error),
  );
  const openAlertModal = useAlertModalStore(state => state.openModal);
  const normalizePhoneNumber = number => number.replace(/[\s\-()+]/g, '');

  const isValidPhoneNumber = number => {
    const cleanNumber = normalizePhoneNumber(number);
    const phoneRegex = /^[1-9]\d{6,14}$/;
    return phoneRegex.test(cleanNumber);
  };
  const hasAlternatePhoneChanged = () => {
    return alternatePhone.trim() !== originalAlternatePhone.trim();
  };

  const handleResetAccount = () => {
    openAlertModal({
      header: 'Resetting account',
      bodyTxt:
        'Continuing this will permanently reset your account and cannot be reverted.',
      buttonText: 'Continue',
      handleConfirmation: async () => {
        await resetAccount();
        // modalFunctions();
      },
    });
  };

  const handleDeleteAccount = () => {
    if (deleteConfirmation.toLowerCase() !== 'delete account') {
      setDeleteError('Please type "delete account" to confirm');
      return;
    }
    resetAccount();
    setShowDeleteModal(false);
    setDeleteConfirmation('');
    setDeleteError('');
  };

  useEffect(() => {
    if (resettingAccountData) {
      window.location.reload();
    }
  }, [resettingAccountData]);

  const [avatarInfo, setAvatarInfo] = useState({
    avatarIcon: faChessBishop,
    avatarName: 'Blazing Bishop',
    avatarTagline:
      'You fancy blazing through the 64 squares, leaving a trail of destruction!',
  });

  const formatData = (data, numColumns) => {
    const numberOfFullRows = Math.floor(data.length / numColumns);

    let numberOfElementsLastRow = data.length - numberOfFullRows * numColumns;
    while (
      numberOfElementsLastRow !== numColumns &&
      numberOfElementsLastRow !== 0
    ) {
      data.push({key: `blank-${numberOfElementsLastRow}`, empty: true});
      numberOfElementsLastRow++;
    }

    return data;
  };

  const {isMobileOrTab} = useMediaQuery();

  const numColumns = 3;

  const renderItem = ({item, index}) => {
    if (item.empty === true) {
      return <View style={[styles?.item, styles?.itemInvisible]} />;
    }
    return (
      <Box
        style={styles?.item}
        onPress={e => {
          setAvatarInfo({
            avatarIcon: item.icon,
            avatarName: item.name,
            avatarTagline: item.tagline,
          });
        }}>
        <FontAwesomeIcon icon={item.icon} size="x" color="black" />
        <Spacer spacing={12} />
        <CCText style={styles?.itemText}>{item.name}</CCText>
      </Box>
    );
  };

  const handleProfileGetSuccess = responseData => {
    console.log('Profile Data = ', responseData);
    setSuccess(false);
    setErrorMsg(null);
    setAllowUpdate(true);
    const user = responseData.data.user[0].fields;
    const avatarData = responseData.data.avatar[0].fields;
    const userSettings = responseData.data.user_settings;
    if (userSettings?.allow_challenge) {
      gameplayStore?.setAllowChallenge(userSettings?.allow_challenge);
    }
    if (userSettings?.chessboard_theme) {
      setColor(userSettings?.chessboard_theme);
    }
    setFirstName(user.first_name);
    setLastName(user.last_name);
    setEmail(user.email);
    setUserName(user.username);
    setPhone(user.mobile_number);
    setAlternatePhone(user.alternate_mobile_number);
    setOriginalAlternatePhone(user.alternate_mobile_number);
    setFideid(user.fide_id || '');
    setLichessUsername(user.lic_name);
    setCdcUsername(user.cdc_name);
    setNewCdcUsername(user.cdc_name);
    setNewLichessUsername(user.lic_name);
    setAvatar(avatarData.avatarDP);
    setAvatarDP(avatarData.avatar);
    if (user?.lic_name?.trim()) {
      setIsDisabled(true);
    }
    if (user?.cdc_name?.trim()) {
      setIsSaved(true);
    }
    if (user.email !== '') {
      setIsEmailDisabled(true);
    }
    if (user.fide_id !== 0) {
      setIsFideDisabled(true);
    }
    if (user.player_type === 1) {
      setPlayerType('beginner');
    } else if (user.player_type === 2) {
      setPlayerType('pro');
    } else {
      setPlayerType(undefined);
    }
    if (
      responseData.data.user_flags.hasOwnProperty('reset_button_enabled') &&
      responseData.data.user_flags.reset_button_enabled !== 0
    ) {
      setUserFlagResetButton(true);
    } else {
      setUserFlagResetButton(false);
    }
    setProfileData(responseData);
  };

  const getUserInfo = async () => {
    const userDetails = await getLocalStorage('user_details');

    if (userDetails) {
      console.log('userDetails', userDetails);

      return userDetails;
    }
  };
  const handleProfileUpdateSuccess = async responseData => {
    setSuccess(true);
    const getUserDetails = await getUserInfo();
    let parseUserDetails = JSON.parse(getUserDetails);
    parseUserDetails.last_name = responseData.data[0].fields.last_name;
    parseUserDetails.first_name = responseData.data[0].fields.first_name;
    parseUserDetails.username = responseData.data[0].fields.username;
    parseUserDetails.fide_id = responseData.data[0].fields.fide_id;
    parseUserDetails.lic_name = responseData.data[0].fields.lic_name;
    parseUserDetails.cdc_name = responseData.data[0].fields.cdc_name;
    parseUserDetails.email = responseData.data[0].fields.email;
    const updatedUserDetails = JSON.stringify(parseUserDetails);
    console.log('updated user details', updatedUserDetails);
    // setUserData(parseUserDetails);
    setUserData(prevData => {
      const updatedData = {
        ...prevData,
        player_type: responseData.data[0].fields.player_type,
      };
      return updatedData;
    });

    const updateLocalStorage = async () => {
      try {
        await setLocalStorage(
          'user_details',
          updatedUserDetails,
          false,
          () => {},
        );
      } catch (error) {
        console.error('Failed to set local storage:', error);
      }
    };
    updateLocalStorage();

    console.log('Profile Update Respnse = ', responseData);
  };

  const handleProfileUpdateFailure = responseData => {
    console.log('Profile Update Error Respnse = ', responseData);
    setErrorMsg(responseData.error);
  };

  const handleOnError = responseData => {};

  const {
    mutate: getProfile,
    data: validatedData,
    error: validatedError,
    isLoading,
  } = useGetProfileApi(handleProfileGetSuccess, handleOnError);

  // Called when the settings update succeeds
  const handleUpdateSettingsSuccess = (data: any) => {
    console.log('✅ Settings updated successfully:', data);

    if (data?.data) {
      const {allow_challenge, chessboard_theme} = data.data;
      // update local state, context, or UI accordingly
      console.log('New settings:', {allow_challenge, chessboard_theme});
    } else {
      console.warn('Settings update succeeded but returned no data.');
    }
  };

  // Called when the settings update fails
  const handleUpdateSettingsError = (data: any) => {
    console.error('❌ Failed to update settings:', data);

    if (data?.error) {
      // show error toast or message
      console.error('Server error:', data.error);
    } else if (data?.errors) {
      console.error('Validation errors:', data.errors);
    }
  };

  const {
    mutate: updateSettings,
    data: settingsData,
    error: settingsError,
    isLoading: isUpdating,
  } = useUpdateUserSettingsApi(
    handleUpdateSettingsSuccess,
    handleUpdateSettingsError,
  );

  const {
    mutate: saveProfile,
    data: successResults,
    error: errorResults,
    isLoading: savingData,
  } = useUpdateProfileApi(
    handleProfileUpdateSuccess,
    handleProfileUpdateFailure,
  );

  useEffect(() => {
    console.log('Getting Goals .. ');
    setSuccess(false);
    getProfile();
  }, []);

  const getValueOrEmptyString = value => {
    if (value && value.trim().length > 0) {
      return value;
    }

    return '';
  };

  const updateProfile = () => {
    setEditChessUsername(false);
    setNewMobilePopup(false);
    setErrorMsg(null);
    setSuccess(false);
    const payload = {
      first_name: getValueOrEmptyString(firstName),
      last_name: getValueOrEmptyString(lastName),
      email: getValueOrEmptyString(email),
      mobile_number: getValueOrEmptyString(phone),
      alternate_mobile_number: getValueOrEmptyString(alternatePhone),
      fide_id: getValueOrEmptyString('' + fideid),
      lic_name: getValueOrEmptyString(newLichessUsername),
      cdc_name: getValueOrEmptyString(newCdcUsername),
      username: getValueOrEmptyString(userName),
      player_type: playerType === 'beginner' ? 1 : 2,
    };

    if (lastName.trim() === '') {
      setErrorMsg('Please provide a valid Last Name');
      setSuccess(false);
      return;
    }
    setUserData(prevData => {
      const updatedData = {
        ...prevData,
        player_type: payload.player_type,
      };
      return updatedData;
    });
    saveProfile(payload);
  };
  const getUpdatedPlatforms = () => {
    const platforms = [];
    if (newLichessUsername && newLichessUsername !== lichessUsername)
      platforms.push('lichess.org');
    if (newCdcUsername && newCdcUsername !== cdcUsername)
      platforms.push('chess.com');
    return platforms.join(' and ');
  };

  const getPopupText = () => {
    const platforms = getUpdatedPlatforms();
    return `Changing ${platforms} username will result in pulling games from the new account, but games already pulled from the previous username account will not be removed and this would affect assessment and progress report.`;
  };
  const hasUsernameChanged =
    newLichessUsername !== lichessUsername || newCdcUsername !== cdcUsername;
  const handleUpdate = () => {
    if (hasUsernameChanged) {
      if (lichessUsername && newLichessUsername.trim() === '') {
        setErrorMsg('Please provide a valid Lichess username');
        return;
      }
      if (cdcUsername && newCdcUsername.trim() === '') {
        setErrorMsg('Please provide a valid Chess.com username');
        return;
      }

      // if both changed, flag mobile popup for after username
      if (hasAlternatePhoneChanged()) {
        if (alternatePhone.trim() === '') {
          setErrorMsg('Please provide a valid alternate mobile number');
          return;
        }
        if (!isValidPhoneNumber(alternatePhone)) {
          setErrorMsg('Please provide a valid mobile number');
          return;
        }
        setShouldShowMobilePopupNext(true); // 📌 flag it
      }
      setEditChessUsername(true);
    } else if (hasAlternatePhoneChanged()) {
      if (alternatePhone.trim() === '') {
        setErrorMsg('Please provide a valid alternate mobile number');
        return;
      }
      if (!isValidPhoneNumber(alternatePhone)) {
        setErrorMsg('Please provide a valid mobile number');
        return;
      }
      setNewMobilePopup(true);
    } else {
      updateProfile();
    }
  };

  useEffect(() => {
    const storeColor = async () => {
      console.log('color', color);
      await setLocalStorage('color', color);
    };
    storeColor();
    if (color && alowUpdate) {
      updateSettings({chessboard_theme: color});
    }
  }, [color]);
  useEffect(() => {
    const storeMode = async () => {
      console.log('dndMode', dndMode);
      await setLocalStorage('dnd-mode', dndMode);
    };
    storeMode();
  }, [dndMode]);

  useEffect(() => {
    const fetchColor = async () => {
      const tempColor = await getLocalStorage('color');
      // debugger;
      if (tempColor) {
        setColor(tempColor);
      } else {
        setColor('default-yellow-white');
      }
    };
    fetchColor();
  }, []);

  // Display tab content based on active tab
  const renderTabContent = () => {
    if (activeTab === 'profile') {
      return (
        <Box>
          {editChessUsername && (
            <SlideModal
              visible={editChessUsername}
              type="center"
              customStyle={{
                width: isMobileOrTab ? '90%' : '20%',
              }}>
              <PopUp
                cancel={() => setEditChessUsername(false)}
                confirm={() => {
                  setEditChessUsername(false);
                  if (shouldShowMobilePopupNext) {
                    setNewMobilePopup(true);
                    setShouldShowMobilePopupNext(false); // reset flag
                  } else {
                    updateProfile();
                  }
                }}
                text={getPopupText()}
                buttonConfirm={'Confirm'}
              />
            </SlideModal>
          )}
          {newMobilePopup && (
            <SlideModal
              visible={newMobilePopup}
              type="center"
              customStyle={{width: isMobileOrTab ? '90%' : '20%'}}>
              <PopUp
                confirm={updateProfile}
                text={
                  'Please note that alternate number is used to send otp and any other kind of whatsapp notification like webinar reminder.'
                }
                buttonConfirm={'Confirm'}
                cancel={() => setNewMobilePopup(false)}
              />
            </SlideModal>
          )}
          {/* Personal Profile Section */}
          <Box style={styles?.section}>
            <CCText style={styles?.sectionHeader}>Your Personal Profile</CCText>
            <Spacer spacing={vs(12)} />
            <Box style={styles?.row}>
              <CCTextInput
                label="First Name"
                value={firstName}
                onChangeText={setFirstName}
                style={styles?.input}
              />
              <CCTextInput
                label="Last Name"
                value={lastName}
                onChangeText={setLastName}
                style={styles?.input}
              />
            </Box>
            <Box style={styles?.row}>
              <CCTextInput
                label="Username"
                value={userName}
                onChangeText={setUserName}
                style={styles?.input}
              />
              <CCTextInput
                label="Email"
                value={email}
                onChangeText={setEmail}
                disabled={isEmailDisabled}
                style={styles?.input}
              />
            </Box>

            <Box style={styles?.row}>
              <CCTextInput
                onChangeText={text => setPhone(text)}
                label="Phone"
                value={phone}
                inputType="phone"
                disabled={phone}
                style={styles?.input}
              />
              <CCTextInput
                onChangeText={text => {
                  setAlternatePhone(text);
                }}
                label="Alternate Phone Number (with country code)"
                value={alternatePhone}
                inputType="phone"
                disabled={false}
                style={styles?.input}
              />
              <Box style={styles?.input}>
                <CCText
                  fontSize={12}
                  color={CCColors.TextColor.Grey}
                  style={{
                    paddingHorizontal: 6,
                    position: 'absolute',
                    zIndex: 1,
                    background: 'white',
                    left: '2%',
                    top: '-6%',
                  }}>
                  Choose ChessBoard Color
                </CCText>
                <CCSelect
                  label=""
                  selectedValue={color}
                  onValueChange={setColor}
                  items={[
                    {
                      label: 'default-yellow-white',
                      value: 'default-yellow-white',
                    },
                    {label: 'green-white', value: 'green-white'},
                    {label: 'blue-white', value: 'blue-white'},
                  ]}
                  style={{
                    backgroundColor: 'white',
                    borderColor: CCColors.BorderBottom,
                  }}
                />
              </Box>
              <Box style={styles?.input}>
                <CCText
                  fontSize={12}
                  color={CCColors.TextColor.Grey}
                  style={{
                    paddingHorizontal: 6,
                    position: 'absolute',
                    zIndex: 1,
                    background: 'white',
                    left: '2%',
                    top: '-6%',
                  }}>
                  Allow Challenge from
                </CCText>
                <CCSelect
                  label=""
                  selectedValue={
                    gameplayStore.allowChallenge ? 'everyone' : 'nobody'
                  }
                  onValueChange={val => {
                    setDndMode(val);
                    gameplayStore.setAllowChallenge(val === 'everyone');
                  }}
                  items={[
                    {label: 'Everyone', value: 'everyone'},
                    {label: 'Nobody', value: 'nobody'},
                  ]}
                  style={{
                    backgroundColor: 'white',
                    borderColor: CCColors.BorderBottom,
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Player Type Section */}

          <PlayerTypeSelection
            playerType={playerType}
            setPlayerType={setPlayerType}
          />

          {/* Chess Profile Section */}
          <Box style={styles?.section}>
            <CCText style={styles?.sectionHeader}>Your Chess Profile</CCText>
            <Spacer spacing={vs(12)} />
            <Box style={styles?.row}>
              <CCTextInput
                label="FIDE ID"
                value={fideid}
                onChangeText={setFideid}
                disabled={isFideDisabled}
                style={styles?.input}
              />
              <CCTextInput
                label="Lichess Username"
                value={newLichessUsername}
                onChangeText={setNewLichessUsername}
                disabled={false}
                style={styles?.input}
              />
              <CCTextInput
                label="Chess.com Username"
                value={newCdcUsername}
                onChangeText={setNewCdcUsername}
                disabled={false}
                style={styles?.input}
              />
            </Box>
          </Box>

          {/* Error/Success Messages */}
          {errorMsg && <CCText style={styles?.errorText}>{errorMsg}</CCText>}
          {success && (
            <CCText style={styles?.successText}>
              Profile successfully updated!
            </CCText>
          )}

          {/* Save Button */}
          <Box style={styles?.buttonContainer} type="row-center">
            {userFlagResetButton && (
              <CCButton onPress={handleResetAccount} type="outline">
                <CCText>Reset Account</CCText>
              </CCButton>
            )}
            <Spacer spacing={10} horizontal />
            <CCButton onPress={handleUpdate}>
              <CCText>Save</CCText>
            </CCButton>
            <Spacer spacing={10} horizontal />
            <CCButton 
              onPress={() => setShowDeleteModal(true)} 
              type="outline"
              style={{borderColor: CCColors.Red}}>
              <CCText style={{color: CCColors.Red}}>Delete Account</CCText>
            </CCButton>
          </Box>

          {/* Delete Account Modal */}
          <SlideModal
            visible={showDeleteModal}
            type="center"
            customStyle={{
              width: isMobileOrTab ? '90%' : '28%',
              maxWidth: 420,
            }}
            onClose={() => {
              setShowDeleteModal(false);
              setDeleteConfirmation('');
              setDeleteError('');
            }}>
            <Box
              style={{
                padding: vs(20),
                backgroundColor: CCColors.White,
                borderRadius: 12,
              }}>
              {/* Warning Icon */}
              <Box type="row-center" style={{marginBottom: vs(16)}}>
                <Box
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 24,
                    backgroundColor: '#FEE2E2',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    size="lg"
                    color="#DC2626"
                  />
                </Box>
              </Box>

              {/* Title */}
              <CCText
                fontSize={FontSizes[20]}
                style={{
                  fontWeight: 'bold',
                  marginBottom: vs(10),
                  color: '#DC2626',
                  textAlign: 'center',
                }}>
                Delete Account
              </CCText>

              {/* Warning Message */}
              <Box
                style={{
                  padding: vs(12),
                  backgroundColor: '#FEF3C7',
                  borderRadius: 6,
                  borderLeftWidth: 3,
                  borderLeftColor: '#F59E0B',
                  marginBottom: vs(14),
                }}>
                <CCText
                  fontSize={FontSizes[13]}
                  style={{
                    color: '#92400E',
                    lineHeight: 18,
                  }}>
                  ⚠️ This action cannot be undone. This will permanently delete
                  your account and remove all your data.
                </CCText>
              </Box>

              {/* Confirmation Text */}
              <CCText
                fontSize={FontSizes[13]}
                style={{
                  marginBottom: vs(6),
                  fontWeight: '600',
                  color: CCColors.TextColor.Dark,
                }}>
                Type{' '}
                <CCText
                  style={{
                    fontWeight: 'bold',
                    color: '#DC2626',
                  }}>
                  "delete account"
                </CCText>{' '}
                to confirm:
              </CCText>

              {/* Input Field */}
              <CCTextInput
                value={deleteConfirmation}
                onChangeText={text => {
                  setDeleteConfirmation(text);
                  setDeleteError('');
                }}
                placeholder="Type 'delete account'"
                style={{
                  marginBottom: vs(12),
                  borderColor:
                    deleteError ? '#DC2626' : CCColors.BorderBottom,
                  borderWidth: 2,
                  borderRadius: 6,
                }}
              />

              {/* Error Message */}
              {deleteError && (
                <Box
                  style={{
                    padding: vs(10),
                    backgroundColor: '#FEE2E2',
                    borderRadius: 6,
                    marginBottom: vs(12),
                  }}>
                  <CCText
                    fontSize={FontSizes[12]}
                    style={{
                      color: '#DC2626',
                      fontWeight: '500',
                    }}>
                    ❌ {deleteError}
                  </CCText>
                </Box>
              )}

              {/* Action Buttons */}
              <Box type="row-center" style={{marginTop: vs(4), gap: vs(8)}}>
                <CCButton
                  onPress={() => {
                    setShowDeleteModal(false);
                    setDeleteConfirmation('');
                    setDeleteError('');
                  }}
                  type="outline"
                  style={{
                    flex: 1,
                    paddingVertical: vs(10),
                    borderWidth: 2,
                    borderColor: CCColors.BorderBottom,
                    borderRadius: 6,
                  }}>
                  <CCText
                    fontSize={FontSizes[14]}
                    style={{fontWeight: '600'}}>
                    Cancel
                  </CCText>
                </CCButton>
                <CCButton
                  onPress={handleDeleteAccount}
                  style={{
                    flex: 1,
                    paddingVertical: vs(10),
                    backgroundColor: resettingAccountLoader
                      ? '#9CA3AF'
                      : '#DC2626',
                    borderRadius: 6,
                    shadowColor: '#000',
                    shadowOffset: {width: 0, height: 2},
                    shadowOpacity: 0.1,
                    shadowRadius: 4,
                    elevation: 3,
                  }}
                  disabled={resettingAccountLoader}>
                  <Box type="row-center">
                    {!resettingAccountLoader && (
                      <>
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          size="sm"
                          color={CCColors.White}
                        />
                        <Spacer spacing={6} horizontal />
                      </>
                    )}
                    <CCText
                      fontSize={FontSizes[14]}
                      style={{color: CCColors.White, fontWeight: '600'}}>
                      {resettingAccountLoader
                        ? 'Deleting...'
                        : 'Delete Account'}
                    </CCText>
                  </Box>
                </CCButton>
              </Box>
            </Box>
          </SlideModal>
        </Box>
      );
    } else if (activeTab === 'subscriptions') {
      return <SubscriptionManagement userData={userData} />;
    }
  };

  const isSuperAdmin = useMemo(() => {
    console.log('userData.user_id', userData.user_id);
    return SUPER_ADMIN?.includes(userData.user_id);
  }, [userData.user_id]);

  return (
    <Box flex={1} style={styles?.container}>
      <CCLoader
        loading={savingData || resettingAccountLoader}
        textToShow={
          resettingAccountLoader
            ? 'Resetting your account—cross your fingers!'
            : ''
        }
      />
      <CCText style={styles?.header}>Your CircleChess Profile</CCText>
      <Spacer spacing={vs(20)} />

      {/* Tab Navigation */}
      {isSuperAdmin && (
        <>
          <Box style={styles.tabContainer}>
            <CCButton
              onPress={() => setActiveTab('profile')}
              type={activeTab === 'profile' ? 'fill' : 'outline'}
              style={styles.tabButton}>
              <Box style={styles.tabContent}>
                <FontAwesomeIcon
                  icon={faUser}
                  size={16}
                  color={
                    activeTab === 'profile'
                      ? CCColors.White
                      : CCColors.TextColor.Primary
                  }
                />
                <Spacer spacing={8} horizontal />
                <CCText>Profile</CCText>
              </Box>
            </CCButton>

            {userData?.is_staff && (
              <CCButton
                onPress={() => setActiveTab('subscriptions')}
                type={activeTab === 'subscriptions' ? 'fill' : 'outline'}
                style={styles.tabButton}>
                <Box style={styles.tabContent}>
                  <FontAwesomeIcon
                    icon={faCreditCard}
                    size={16}
                    color={
                      activeTab === 'subscriptions'
                        ? CCColors.White
                        : CCColors.TextColor.Primary
                    }
                  />
                  <Spacer spacing={8} horizontal />
                  <CCText>Manage Subscriptions</CCText>
                </Box>
              </CCButton>
            )}
          </Box>
        </>
      )}
      <Spacer spacing={vs(10)} />
      <View style={styles.tabs}>
        <TouchableOpacity
          style={[styles.tab, userTabs === 'profile' && styles.activeTab]}
          onPress={() => setUserTabs('profile')}>
          <CCText style={styles.tabText}>Profile</CCText>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.tab,
            userTabs === 'caissa_subscription' && styles.activeTab,
          ]}
          onPress={() => setUserTabs('caissa_subscription')}>
          <CCText style={styles.tabText}>Caissa Subscription</CCText>
        </TouchableOpacity>
      </View>
      {userTabs === 'profile' && renderTabContent()}
      {userTabs === 'caissa_subscription' && (
        <SubscriptionTab profileData={profileData} />
      )}
    </Box>
  );
}

export default Profile;
